import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import * as React from "react";

import Prop65Component from "@tCooneyBrothers/Components/Prop65Component";

type props = WidgetProps;

const Prop65: React.FC<props> = props => {
    return <Prop65Component messageToDisplay=""></Prop65Component>;
};

const widgetModule: WidgetModule = {
    component: Prop65,
    definition: {
        displayName: "Prop65",
        group: "Product Details",
        allowedContexts: [ProductDetailsPageContext],
    },
};

export default widgetModule;
